import { ISellerRankState } from 'v3/data/store/Rank/RankSeller/types';

export const sellerRankInitialState: ISellerRankState = {
  list: {
    count: 0,
    items: [],
  },
  filter: {
    finalDate: undefined,
    startDate: undefined,
    page: 0,
    rowsPerPage: 20,
  },
  data: {
    id: '',
    sellerName: '',
    sales: 0,
    store: '',
    group: '',
  },
  report: {
    jobId: null,
    status: 'IDLE',
    url: null,
    startDate: undefined,
    finalDate: undefined,
  },
};
